import React from 'react';
import { Download, FileText, BookOpen } from 'lucide-react';
import { siteInfo } from '../data/mock';

export default function BrochureBanner() {
  return (
    <section className="py-14 bg-navy">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-pink-brand/40 bg-gradient-to-br from-navy-dark via-navy-light to-navy-dark p-8 lg:p-10">
          <div className="absolute -right-10 -top-10 w-52 h-52 rounded-full bg-pink-brand/20 blur-3xl"></div>
          <div className="absolute -left-10 -bottom-10 w-52 h-52 rounded-full bg-pink-brand/15 blur-3xl"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
            <div className="flex-shrink-0 w-20 h-20 lg:w-24 lg:h-24 rounded-2xl bg-pink-brand flex items-center justify-center shadow-xl animate-float">
              <BookOpen size={40} className="text-white" />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-pink-brand/20 border border-pink-brand rounded-full px-3 py-1 mb-3">
                <FileText size={12} className="text-pink-brand" />
                <span className="text-pink-brand text-[10px] font-bold uppercase tracking-widest">PDF · Ufficiale</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white uppercase mb-2">
                Scarica la Brochure Completa
              </h3>
              <p className="text-white/75 text-sm lg:text-base max-w-xl">
                Tutto il programma del XIV Memorial, regolamento, squadre, gironi, calendari e partner in un unico documento stampabile.
              </p>
            </div>

            <a
              href={siteInfo.brochurePdf}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="btn-primary flex-shrink-0 text-sm"
            >
              <Download size={18} /> Scarica PDF
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
